import { basicChannel } from 'src/channels/basic.channel';
import { EOverlayContentWidth, POSITIONS } from 'Components/shared/Overlay/elements/OverlayFixedBg/types';
import { BrandOverlayBottom } from './brandOverlaysTypes';
import { IBrandBonusOverride } from './contents/universal/BrandBonusOverride/types';
import { IBrandBonusWheelDescriptionContent } from './contents/unique/BrandBonusWheelDescription/types';
import { IBrandBonusWheelInfo } from './contents/universal/BrandBonusWheelInfo/types';
import { IBrandNoBonusLuckyWheel } from './contents/unique/BrandNoBonusLuckyWheel/types';
import { IBrandBonusHasLuckyWheelContent } from './contents/unique/BrandBonusHasLuckyWheel/types';
import { IBrandBonusDescriptionsContent } from './contents/BrandBonusDescriptions/types';
import { IBrandBonusWheelDescriptionLargeContent } from './contents/unique/BrandBonusWheelDescriptionLarge/types';
import { EBasicOverlays } from 'Components/shared/Overlay/elements/BasicOverlayManager/types';

/**description list of wheel bonus  */
export const getOverlayBonusWheelDescription = (content: IBrandBonusWheelDescriptionContent) => {
  // custom: without backfround color
  basicChannel.send({
    action: 'display',
    data: {
      content: {
        type: EBasicOverlays.BrandBonusWheelDescription,
        withoutPadding: true,
        bottom: true,
        width480: true,
        noRoundedCorners: true,
        withoutBackground: true,
        ...content,
      },
      isBgTransparent: true,
      blurBgWheel: true,
      onClose: () => {
        if (typeof content?.onClose === 'function') {
          content?.onClose?.();
        }
      },
      position: POSITIONS.CENTER,
      contentWidth: EOverlayContentWidth.AUTO,
    },
  });
};
export const getOverlayNoBonusWheel = (content: IBrandNoBonusLuckyWheel) => {
  // custom: without backfround color
  basicChannel.send({
    action: 'display',
    data: {
      content: {
        type: EBasicOverlays.BrandNoBonusLuckyWheel,
        withoutPadding: true,
        bottom: true,
        width480: true,
        noRoundedCorners: true,
        withoutBackground: true,
        ...content,
      },
      onClose: () => {
        if (typeof content?.button?.onClickEvent === 'function') {
          content?.button?.onClickEvent?.();
        }
      },
      isBgTransparent: true,
      blurBgWheel: true,
      position: POSITIONS.CENTER,
      contentWidth: EOverlayContentWidth.AUTO,
    },
  });
};
export const getOverlayBonusOverride = (content: IBrandBonusOverride) => {
  BrandOverlayBottom(EBasicOverlays.BrandBonusOverride, content);
};
export const getOverlayBonusInfo = (content: IBrandBonusWheelInfo) => {
  BrandOverlayBottom(EBasicOverlays.BrandBonusWheelInfo, content);
};
export const getOverlayBonusWheelDescriptionLarge = (content: IBrandBonusWheelDescriptionLargeContent) => {
  BrandOverlayBottom(EBasicOverlays.BrandBonusWheelDescriptionLarge, content);
};
// custom overlay
export const getOverlayHasLuckyWheelBonus = (content: IBrandBonusHasLuckyWheelContent) => {
  basicChannel.send({
    action: 'display',
    data: {
      content: {
        type: EBasicOverlays.BrandBonusHasLuckyWheel,
        withoutPadding: true,
        bottom: true,
        width720: true,
        noRoundedCorners: true,
        withoutBackground: true,
        widthCustom: true,
        ...content,
      },
      onClose: () => {
        content?.onClose?.();
      },
      position: POSITIONS.CENTER,
      contentWidth: EOverlayContentWidth.AUTO,
    },
  });
};

export const getOverlayBonusDescriptions = (content: IBrandBonusDescriptionsContent) => {
  BrandOverlayBottom(EBasicOverlays.BrandBonusDescriptions, content);
};

export const getOverlayAccount = (action: 'display' | 'close', onClose?: () => void) => {
  basicChannel.send({ action: 'close' });
  basicChannel.send({
    action: action,
    data: {
      content: {
        type: EBasicOverlays.HeaderAccount,
        withoutPadding: true,
        full: true,
        noRoundedCorners: true,
        hideOverlayHeader: true,
        onClickHeaderClose: () => {
          onClose?.();
        },
      },
      onClose: () => {
        onClose?.();
      },
      position: POSITIONS.RIGHT_TOP,
      isBgTransparent: true,
      backgroundFitContent: false,
      contentWidth: EOverlayContentWidth.AUTO,
      enableScroll: true,
      isNotification: true,
    },
  });
};

// has only one type of this overlay
export const getOverlaySearch = (filter?: boolean, onlyMobile?: boolean) => {
  basicChannel.send({
    action: 'display',
    data: {
      content: {
        type: EBasicOverlays.SearchOverlay,
        searchOverlay: true,
        hideOverlayHeader: true,
        onlyMobile: onlyMobile,
        filter: filter,
        onClose: () => {
          basicChannel.send({ action: 'close' });
        },
      },
      position: POSITIONS.CENTER,
      contentWidth: EOverlayContentWidth.FULL_SCREEN,
    },
  });
};
